<div class="chart-container" data-test-id="pie-chart-container">
  <canvas id="MyChart" data-test-id="pie-chart-canvas">{{ chart }}</canvas>
</div>
